module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-circle-d897888b.svg";